export default __webpack_public_path__ + "static/media/Midnight 1.e4cd5bad.png";